// @flow
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import storage from 'lib/storage';
import { Forbidden } from 'pages';
import { connect } from 'react-redux';
import type { State } from 'store';
import { compose } from 'redux';
import { UserActions } from 'store/actionCreators';

type Props = {
  // component: React.Component<*,*>,
  // 리액트 컴포넌트의 경우 flow type을 어떻게 해야 에러가 발생하지 않는지 알 수가 없어서 우선 any로 하였습니다.
  component: any,
  path: string,
  exact?: boolean,
};
const PrivateRoute = ({ component: Component, path, exact, ...rest }: Props) => {
  const user = storage.get('__datasee_user__');
  const rule = user && user.rule;

  // props로 넘어오는 유저 rule이 아무것도 없을 때 isRestricted는 false가 되어야 한다.
  // 기본적으로 rest에 2개의 props는 담겨 있다.
  const restProps = Array.from(Object.keys(rest));
  const isRestricted = restProps.length === 3 ? false : restProps.indexOf(rule) <= -1;

  // 로그인과 회원가입의 경우 로그인이 된 상태라면 홈으로 리다이렉션 처리
  if (path === '/login' || path === '/register' || path === '/forgot') {
    return user ? <Redirect to={'/'} /> : <Route path={path} component={Component} />;
  }

  if (rest.success === false) {
    UserActions.checkUser();
    return null;
  }

  // 1. user 정보가 있고, 사용자가 권한이 없는 경우
  // 2. user 정보가 있고, 사용자가 권한이 있는 경우
  // 3. user 정보가 없는 경우(로그인이 되어 있지 않은)
  return user ? (
    isRestricted ? (
      <Route component={Forbidden} />
    ) : (
      <Route exact={exact} path={path} component={Component} />
    )
  ) : (
    <Redirect to={'/login'} />
  );
};

export default compose(
  connect(
    ({ pender }: State) => ({
      success: pender.success['user/CHECK_USER'],
    }),
    () => ({}),
  ),
)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/privateRoute/PrivateRoute.js